import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionFlowSessionStore} from '../state/question-flow-session.store';

@Component({
    selector: 'app-question-security-code',
    templateUrl: './question-security-code.component.html',
    styleUrls: ['./question-security-code.component.scss'],
    standalone: false
})
export class QuestionSecurityCodeComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() items: any[] = [];
  @Output() questionAnswer = new EventEmitter<any>();

  securityCode = '';
  uniqueControlName = `security-code-${newGuid()}`;

  constructor(
    public router: Router,
    private globalQuestionService: GlobalQuestionService,
    private questionFlowSessionStore: QuestionFlowSessionStore) { }

  ngOnInit(): void {
    this.router.onSameUrlNavigation = 'reload';
    this.globalQuestionService.getSecurityCode()
      .subscribe((code: any[]) => {
        if (!code?.length){
          return;
        }
        this.securityCode = code[0]?.security_code;
        this.questionFlowSessionStore.update({ emergency_code: +this.securityCode });
        document.querySelector('body')?.removeAttribute('class');//force rebuild bar
        document.querySelector('body')?.classList.add('page');
        document.querySelector('body')?.classList.add('page--claims');
        document.querySelector('body')?.classList.add('page--claims-code');
        this.router.navigateByUrl("/question-flow");
      });
  }

}
